// Kit de estilos compartido para modales de carga/edición.
// Basado en el theme de Axon Capital. Replica el patrón del modal de Operaciones:
// overlay oscuro, contenedor flex en columna con título fijo, área scrolleable y
// footer de botones fijo. No reemplaza a config/styles.js (legacy), es aditivo.

import { theme } from './theme';

// Estilos consumidos por el componente <Modal>.
export const modalStyles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(17, 24, 39, 0.8)',
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        zIndex: 2000, padding: '1rem',
    },
    content: {
        backgroundColor: theme.colors.background, padding: '1.25rem 2rem', borderRadius: '8px',
        width: '90%', maxWidth: '800px', maxHeight: '90vh', overflow: 'hidden',
        boxShadow: theme.shadows.soft, display: 'flex', flexDirection: 'column',
    },
    formColumn: { display: 'flex', flexDirection: 'column', flex: '1 1 auto', minHeight: 0 },
    scrollArea: { overflowY: 'auto', flex: '1 1 auto', minHeight: 0 },
    title: {
        fontFamily: theme.typography.titleFamily, fontSize: '1.5rem', color: theme.colors.primary,
        margin: '0 0 0.75rem 0', flexShrink: 0,
    },
    actions: {
        marginTop: '0.85rem', paddingTop: '0.85rem', borderTop: `1px solid ${theme.colors.border}`,
        display: 'flex', justifyContent: 'flex-end', gap: '1rem', flexShrink: 0,
    },
    errorBanner: {
        color: theme.colors.errorText, backgroundColor: theme.colors.error,
        padding: '0.75rem', borderRadius: theme.borderRadius, marginBottom: '1rem', textAlign: 'center',
    },
};

// Kit de campos para los cuerpos de los modales (consistencia con Operaciones).
export const fieldStyles = {
    formGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.85rem 1.5rem' },
    formGroup: { gridColumn: 'span 1' },
    formGroupHalf: { gridColumn: 'span 1' },
    formGroupDouble: { gridColumn: 'span 2' },
    formGroupFull: { gridColumn: 'span 3' },
    label: {
        display: 'block', marginBottom: '0.3rem', fontSize: '0.875rem', fontWeight: '500',
        color: theme.colors.secondary,
    },
    input: {
        width: '100%', padding: '0.5rem 0.75rem', border: `1px solid ${theme.colors.border}`,
        borderRadius: theme.borderRadius, fontSize: '0.875rem', boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
    },
    select: {
        width: '100%', padding: '0.5rem 0.75rem', border: `1px solid ${theme.colors.border}`,
        borderRadius: theme.borderRadius, fontSize: '0.875rem', backgroundColor: theme.colors.surface,
        fontFamily: theme.typography.fontFamily, boxSizing: 'border-box',
    },
    textarea: {
        width: '100%', padding: '0.5rem 0.75rem', border: `1px solid ${theme.colors.border}`,
        borderRadius: theme.borderRadius, fontSize: '0.875rem', boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily, minHeight: '52px', resize: 'vertical',
    },
    sectionHeader: {
        gridColumn: '1 / -1', fontFamily: theme.typography.titleFamily, fontSize: '0.8rem', fontWeight: '600',
        textTransform: 'uppercase', letterSpacing: '0.05em', color: theme.colors.primary,
        borderBottom: `1px solid ${theme.colors.border}`, paddingBottom: '0.4rem', marginBottom: '-0.25rem',
    },
    button: {
        fontFamily: theme.typography.fontFamily, backgroundColor: theme.colors.primary, color: theme.colors.textPrimary,
        border: 'none', borderRadius: theme.borderRadius, padding: '0.75rem 1.5rem', fontSize: '0.9rem',
        fontWeight: '600', cursor: 'pointer', transition: 'background-color 0.2s',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem',
    },
    secondaryButton: { backgroundColor: theme.colors.border, color: theme.colors.secondary },
    // Estilos reutilizables para react-select dentro de un modal (evita recorte por overflow:hidden).
    reactSelect: {
        control: (base) => ({
            ...base, minHeight: '38px', borderColor: theme.colors.border, fontSize: '0.875rem',
        }),
        menuPortal: (base) => ({ ...base, zIndex: 10000 }),
        menu: (base) => ({ ...base, zIndex: 10000 }),
    },
};
